<template>
  <div
    class="ratingContainer"
    @mouseover="hover = true" @mouseleave="hover = false"
    @click.stop.prevent
  >
    <div class="ratingBar">
      <v-rating
        length="5"
        hover
        class="rating"
      >
        <template v-slot:item="props">
          <span
            class="ratingItem"
            :style="getColor(props.index)"
            @click.exact="update(props.index)"
            @click.stop.prevent
            @mouseover="onMouseOver(props.index)"
            @mouseleave="onMouseLeave()"
          >
            {{ getIcon(props.index) }}
          </span>
        </template>
      </v-rating>
      <div v-show="hover" class="section-rating-description">
        <span>
          <v-tooltip
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                class="rating-help-icon"
                size="14"
                v-bind="attrs"
                v-on="on"
              >
                help
              </v-icon>
            </template>
            <span>
              {{ $t('views.journal.cards.actions.rate.tooltip') }}
            </span>
          </v-tooltip>
          <span class="rating-description">
            {{ getTextDescription() }}
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
import { types } from '@/store/rootTypes';

export default {
  name: 'RecommendationRating',
  data: () => ({
    rating: 0,
    hoverIndex: -1,
    hover: false,
  }),
  props: {
    recommendation: {
      type: Object,
      required: true,
    },
  },
  created() {
    this.updateData();
  },
  methods: {
    ...mapActions({
      recommendationRated: types.recommendationBasedJournals.actions.recommendationRated,
    }),
    update(index) {
      if (this.recommendation.rating === index + 1) return;

      this.rating = index + 1;
      this.hoverIndex = index;
      console.log(`[RecommendationRating] Rated recommendation '${this.recommendation.id}' with value ${this.rating}`);
      this.recommendationRated({ recommendation: this.recommendation, rating: this.rating });
    },
    onMouseOver(index) {
      this.hoverIndex = index;
    },
    onMouseLeave() {
      this.updateData();
    },
    getIcon(index) {
      if (index <= this.hoverIndex) {
        return '●';
      }
      return '○';
    },
    getColor(index) {
      if (index <= this.hoverIndex && this.hover) {
        return 'color: #3F47CD;';
      }
      return 'color: rgb(150, 150, 150)';
    },
    updateData() {
      if (this.recommendation.rating) {
        this.rating = this.recommendation.rating;
      } else {
        this.rating = 0;
      }

      this.hoverIndex = this.rating - 1;
    },
    getTextDescription() {
      if ([0, 1, 2, 3, 4].includes(this.hoverIndex)) {
        const options = this.$t(`views.journal.cards.actions.rate.descriptions.${this.hoverIndex}`);
        return this.sampleFrom(options);
      }
      return '';
    },
    sampleFrom(list) {
      return list[Math.floor(Math.random() * list.length)];
    },
  },
};
</script>
<style scope>
.ratingContainer {
  width: 100%;
  margin-top: 8px;
  margin-left: 16px;
  font-size: 10px;
  color: #aaa;
}
.ratingBar {
  display: flex;
  font-size: 12px;
  color: #aaa;
  align-items: center;
  justify-content: flex-start;
  margin-right:auto;
}
.ratingContainer * {
  padding-right: 4px;
}
.section-rating-description {
  position: absolute;
  height: 24px;
  margin-bottom: 32px;
}
.rating-help-icon {
  font-size: 12px;
}
.rating-description {
  color: #3F47CD;
  font-weight: 600;
  font-size: 12px;
}
.ratingItem {
  font-size: 20px;
  height: 20px;
  font-weight: 1000;
}
.ratingItem:hover {
  cursor: pointer;
}
</style>
